export default __webpack_public_path__ + "static/media/1352.c2bcf1f7.png";